<template>
  <Timer
    v-model="timeRemaining"
    :time="challengeStartedAt"
    text-class="text-theme"
  >
    <template slot="prefix">
      Tempo restante: 
    </template>
  </Timer>
</template>
<script>

import Timer from './Timer'

export default {
  components: {
    Timer,
  },
  props: {
    challenge: {
      type: Object,
      required:true,
    }
  },
  data() {
    return {
      timeRemaining: 0,
    }
  },
  computed: {
    challengeStartedAt() {
      return this.challenge.started_at ? this.$moment(this.challenge.started_at)
        .add(this.challenge.minutes, 'minutes')
        .valueOf() : null;
    },
  },
  watch: {
    timeRemaining(value) {
      if (value < 1000 && !this.challenge.finished_at) {
        this.end()
      }
      this.$emit('input', value);
    }
  },
}
</script>
